import React from 'react';
import classNames from 'classnames';
import ProductsList from './ProductsList';
import CustomSelect from '../common/CustomSelect';

const OptionsBar = (props) => {

    const
        listLayoutClass = classNames('list-view-btn', {'list-view-btn--active': props.layoutType === ProductsList.layoutTypes.list}),
        gridLayoutClass = classNames('tiles-view-btn', {'tiles-view-btn--active': props.layoutType === ProductsList.layoutTypes.grid});

    const {
        itemsPerPage,
        onItemsQuantityChange,
        onLayoutChange
    } = props;

    const selectLabelId = 'itemsPerPageLabel';

        return (
            <div className="options-bar">
                <div className="options-bar__item" aria-controls="productsList">
                    <span className="options-bar__filter-label" id={selectLabelId}>Results on the page</span>
                    <CustomSelect
                        labelId={selectLabelId}
                        optionsListName="itemsPerPage"
                        selectedOption={itemsPerPage}
                        options={OptionsBar.itemsQuantities}
                        onValueSelection={onItemsQuantityChange}
                    />
                </div>

                <div className="options-bar__item">
                    <span className="options-bar__filter-label">View</span>
                    <a href="#"
                       className={listLayoutClass}
                       onClick={(e) => onLayoutChange(e, ProductsList.layoutTypes.list)}
                    />
                    <a href="#"
                       className={gridLayoutClass}
                       onClick={(e) => onLayoutChange(e, ProductsList.layoutTypes.grid)}
                    />
                </div>
            </div>
        )
};

OptionsBar.itemsQuantities = ['12', '24', '48'];

export default OptionsBar;
